import { useEffect, useCallback, useState } from "react";
import useGlobalState from "@/hooks/useGlobalState";

export default function useToggleStatus(key: "claimerMintToggleStatus") {
  const [claimerMintToggleStatus, setClaimerMintToggleStatus] =
    useGlobalState(key);

  const toggle = useCallback(
    (key: string) => {
      const data: any = { ...claimerMintToggleStatus };
      if (data[key]) {
        data[key] = !data[key];
      } else {
        const keys = Object.keys(claimerMintToggleStatus);
        keys.forEach((key) => {
          data[key] = false;
        });
        data[key] = true;
      }

      setClaimerMintToggleStatus(data);
    },
    [claimerMintToggleStatus]
  );

  const open = useCallback(
    (key: string) => {
      const keys = Object.keys(claimerMintToggleStatus);
      const data: any = { ...claimerMintToggleStatus };
      keys.forEach((key) => {
        data[key] = false;
      });
      data[key] = true;
      setClaimerMintToggleStatus(data);
    },
    [claimerMintToggleStatus]
  );

  const close = useCallback(
    (key: string) => {
      const data: any = { ...claimerMintToggleStatus };
      data[key] = false;
      setClaimerMintToggleStatus(data);
    },
    [claimerMintToggleStatus]
  );

  const closeAll = useCallback(() => {
    const keys = Object.keys(claimerMintToggleStatus);
    const data: any = { ...claimerMintToggleStatus };
    keys.forEach((key) => {
      data[key] = false;
    });
    setClaimerMintToggleStatus(data);
  }, [claimerMintToggleStatus]);

  return {
    open,
    close,
    toggle,
    closeAll,
    claimerMintToggleStatus,
  };
}
